import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import useUser from "../user/useUser";
import { isListingSaved } from "../../api/listings";
import { setIsSavedListing } from "../../redux/pages/trainingPlanSlice";
import { useEffect } from "react";

export const useSavedListing = () => {
  const trainingPlanRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const { user } = useUser();
  const dispatch = useDispatch();

  useEffect(() => {
    const getSavedListingData = async () => {
      try {
        if (user?.token) {
          const savedListing = await isListingSaved(
            trainingPlanRedux.id,
            user.token,
          );

          dispatch(setIsSavedListing(savedListing));
        }
      } catch (e) {
        console.error(e);
      }
    };

    void getSavedListingData();
  }, [dispatch, trainingPlanRedux.id, user?.token]);
};
